/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { FavouriteProfileCommandParams } from '../models/favourite-profile-command-params';
import { FavouriteProfilesModel } from '../models/favourite-profiles-model';
import { FormworkId } from '../models/formwork-id';

@Injectable({ providedIn: 'root' })
export class FavoriteProfilesApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAll()` */
  static readonly GetAllPath = '/api/v1/favorite-profiles';

  /**
   * Returns all favorites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAll$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll$Plain$Response(
    params?: {
      doka360ProjectUid?: string;
      formworkSystemId?: FormworkId;
      isStandard?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FavouriteProfilesModel>>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.GetAllPath, 'get');
    if (params) {
      rb.query('doka360ProjectUid', params.doka360ProjectUid, {});
      rb.query('formworkSystemId', params.formworkSystemId, {});
      rb.query('isStandard', params.isStandard, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FavouriteProfilesModel>>;
      })
    );
  }

  /**
   * Returns all favorites.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAll$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll$Plain(
    params?: {
      doka360ProjectUid?: string;
      formworkSystemId?: FormworkId;
      isStandard?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<FavouriteProfilesModel>> {
    return this.getAll$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FavouriteProfilesModel>>): Array<FavouriteProfilesModel> => r.body)
    );
  }

  /**
   * Returns all favorites.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll$Response(
    params?: {
      doka360ProjectUid?: string;
      formworkSystemId?: FormworkId;
      isStandard?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FavouriteProfilesModel>>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.GetAllPath, 'get');
    if (params) {
      rb.query('doka360ProjectUid', params.doka360ProjectUid, {});
      rb.query('formworkSystemId', params.formworkSystemId, {});
      rb.query('isStandard', params.isStandard, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FavouriteProfilesModel>>;
      })
    );
  }

  /**
   * Returns all favorites.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAll(
    params?: {
      doka360ProjectUid?: string;
      formworkSystemId?: FormworkId;
      isStandard?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<FavouriteProfilesModel>> {
    return this.getAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FavouriteProfilesModel>>): Array<FavouriteProfilesModel> => r.body)
    );
  }

  /** Path part for operation `createFavoriteProfile()` */
  static readonly CreateFavoriteProfilePath = '/api/v1/favorite-profiles';

  /**
   * Add a new favoriteProfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFavoriteProfile$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createFavoriteProfile$Plain$Response(
    params: {
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.CreateFavoriteProfilePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Add a new favoriteProfile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFavoriteProfile$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createFavoriteProfile$Plain(
    params: {
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<number> {
    return this.createFavoriteProfile$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * Add a new favoriteProfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFavoriteProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createFavoriteProfile$Response(
    params: {
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.CreateFavoriteProfilePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Add a new favoriteProfile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFavoriteProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createFavoriteProfile(
    params: {
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<number> {
    return this.createFavoriteProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getFavoriteProfile()` */
  static readonly GetFavoriteProfilePath = '/api/v1/favorite-profiles/{favoriteId}';

  /**
   * Get favoriteProfile per ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFavoriteProfile$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteProfile$Plain$Response(
    params: {
      favoriteId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FavouriteProfilesModel>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.GetFavoriteProfilePath, 'get');
    if (params) {
      rb.path('favoriteId', params.favoriteId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FavouriteProfilesModel>;
      })
    );
  }

  /**
   * Get favoriteProfile per ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFavoriteProfile$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteProfile$Plain(
    params: {
      favoriteId: number;
    },
    context?: HttpContext
  ): Observable<FavouriteProfilesModel> {
    return this.getFavoriteProfile$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<FavouriteProfilesModel>): FavouriteProfilesModel => r.body)
    );
  }

  /**
   * Get favoriteProfile per ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFavoriteProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteProfile$Response(
    params: {
      favoriteId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FavouriteProfilesModel>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.GetFavoriteProfilePath, 'get');
    if (params) {
      rb.path('favoriteId', params.favoriteId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FavouriteProfilesModel>;
      })
    );
  }

  /**
   * Get favoriteProfile per ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFavoriteProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFavoriteProfile(
    params: {
      favoriteId: number;
    },
    context?: HttpContext
  ): Observable<FavouriteProfilesModel> {
    return this.getFavoriteProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<FavouriteProfilesModel>): FavouriteProfilesModel => r.body)
    );
  }

  /** Path part for operation `updateFavoriteProfile()` */
  static readonly UpdateFavoriteProfilePath = '/api/v1/favorite-profiles/{favoriteId}';

  /**
   * Update existing favoriteProfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFavoriteProfile$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFavoriteProfile$Plain$Response(
    params: {
      favoriteId: number;
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FavouriteProfilesModel>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.UpdateFavoriteProfilePath, 'put');
    if (params) {
      rb.path('favoriteId', params.favoriteId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FavouriteProfilesModel>;
      })
    );
  }

  /**
   * Update existing favoriteProfile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFavoriteProfile$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFavoriteProfile$Plain(
    params: {
      favoriteId: number;
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<FavouriteProfilesModel> {
    return this.updateFavoriteProfile$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<FavouriteProfilesModel>): FavouriteProfilesModel => r.body)
    );
  }

  /**
   * Update existing favoriteProfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFavoriteProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFavoriteProfile$Response(
    params: {
      favoriteId: number;
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<FavouriteProfilesModel>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.UpdateFavoriteProfilePath, 'put');
    if (params) {
      rb.path('favoriteId', params.favoriteId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FavouriteProfilesModel>;
      })
    );
  }

  /**
   * Update existing favoriteProfile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFavoriteProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateFavoriteProfile(
    params: {
      favoriteId: number;
      body: FavouriteProfileCommandParams
    },
    context?: HttpContext
  ): Observable<FavouriteProfilesModel> {
    return this.updateFavoriteProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<FavouriteProfilesModel>): FavouriteProfilesModel => r.body)
    );
  }

  /** Path part for operation `deleteFavouriteProfile()` */
  static readonly DeleteFavouriteProfilePath = '/api/v1/favorite-profiles/{favoriteId}';

  /**
   * Delete favouriteProfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFavouriteProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFavouriteProfile$Response(
    params: {
      favoriteId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, FavoriteProfilesApiClient.DeleteFavouriteProfilePath, 'delete');
    if (params) {
      rb.path('favoriteId', params.favoriteId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete favouriteProfile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFavouriteProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFavouriteProfile(
    params: {
      favoriteId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.deleteFavouriteProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
